// extracted by mini-css-extract-plugin
export default {"wrapper":"Skirt-SkirtCard-module__wrapper--pzNRn"};